/**
 * Yasuo Wind Wall — destroy enemy skillshots that cross the wall (FID-ABL-16).
 */

import { scaleLolDistance } from '../combat/abilityArea.js';

export const YASUO_W_DURATION_SEC = 4;
/** Half of kit width 350. */
export const YASUO_W_HALF_WIDTH = 175;
export const YASUO_W_THICKNESS = 40;
export const YASUO_W_OFFSET = 80;

const BLOCKED_TYPES = new Set(['skillshot_w', 'hawkshot_e', 'ultimate_r', 'skillshot']);

export function createWindWall(caster, tx, tz, nowSec = 0) {
  const ox = caster?.x ?? 0;
  const oz = Number.isFinite(caster?.z) ? caster.z : (caster?.y ?? 0);
  const aimX = Number.isFinite(tx) ? tx : ox + 1;
  const aimZ = Number.isFinite(tz) ? tz : oz;
  const dx = aimX - ox;
  const dz = aimZ - oz;
  const len = Math.hypot(dx, dz) || 1;
  const fx = dx / len;
  const fz = dz / len;
  const offset = scaleLolDistance(YASUO_W_OFFSET, caster);
  return {
    team: caster.team,
    x: ox + fx * offset,
    z: oz + fz * offset,
    fx,
    fz,
    halfWidth: scaleLolDistance(YASUO_W_HALF_WIDTH, caster),
    thickness: scaleLolDistance(YASUO_W_THICKNESS, caster),
    expiresAt: (Number(nowSec) || 0) + YASUO_W_DURATION_SEC
  };
}

export function isSkillshotBlockedByWindWall(proj, wall, nowSec = 0) {
  if (!proj || !wall) return false;
  if (Number.isFinite(nowSec) && nowSec >= wall.expiresAt) return false;
  const team = proj.sourceEntity?.team ?? proj.team;
  if (!team || team === wall.team) return false;
  const type = proj.type || '';
  if (!BLOCKED_TYPES.has(type)) return false;
  const px = proj.x;
  const pz = Number.isFinite(proj.z) ? proj.z : (proj.y ?? 0);
  const rx = px - wall.x;
  const rz = pz - wall.z;
  const along = -rx * wall.fz + rz * wall.fx;
  const across = rx * wall.fx + rz * wall.fz;
  return Math.abs(along) <= wall.halfWidth && Math.abs(across) <= wall.thickness / 2;
}

export function collectActiveWindWalls(entities = [], nowSec = 0) {
  const walls = [];
  for (const e of entities) {
    const wall = e?.windWall;
    if (!wall) continue;
    if (Number.isFinite(nowSec) && nowSec >= wall.expiresAt) continue;
    walls.push(wall);
  }
  return walls;
}

export function isProjectileBlockedByWindWalls(proj, walls = [], nowSec = 0) {
  for (const wall of walls) {
    if (isSkillshotBlockedByWindWall(proj, wall, nowSec)) return true;
  }
  return false;
}
